export const PcIcon: React.FC<React.SVGAttributes<SVGSVGElement>> = (props) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    fill='none'
    viewBox='0 0 28 21'
    {...props}
  >
    <path
      fill='currentColor'
      d='M23.352 14.5V2.852H4.648V14.5zm-7 3.5v-1.148h-4.704V18zm9.296 0H28v2.352H0V18h2.352V.5h23.296z'
    />
  </svg>
);
